module.exports = __webpack_public_path__ + "static/media/lane_geometry.37dc1830.svg";